var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"trigger":"hover"}},[_c('div',[_c('img',{attrs:{"src":_vm.qrcodeImg}})]),_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("微信查看")]),_c('i',{staticClass:"el-icon-mobile-phone",staticStyle:{"cursor":"pointer"},attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }